<script setup>
import {inject} from "vue";
import ProgressTrackingStatistics from "./_progressTrackingStatistics.vue";

const props = defineProps({
    channelId: {
        type: Number,
        required: true
    }
})

const isVisible = inject('containerTabIsVisible')

</script>

<template>
    <progress-tracking-statistics
        v-if="isVisible"
        :channel-id="channelId"
    ></progress-tracking-statistics>
</template>
